import { HttpErrorResponse } from '@angular/common/http';
import { Component, Input, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, MathUtil } from 'src/app/common/util';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { BillReceivableService } from 'src/app/services/bill-receivable.service';
import { AccountingReportService } from 'src/app/services/reports/accounting-report.service';
@Component({
  selector: 'app-bill-receivable-chronology',
  templateUrl: './bill-receivable-chronology.component.html',
  styleUrls: ['./bill-receivable-chronology.component.scss']
})
export class BillReceivableChronologyComponent implements OnInit {
  start: any = "";
  end: any = "";
  type = 2;
  option = null;
  loadingChart = false;
  results = [];
  categories = [];
  options = [];

  constructor(
    private toastService: ToastrService,
    private billService: BillReceivableService,
    private reportService: AccountingReportService
  ) {

  }

  ngOnInit(): void {
    var today = new Date(DateUtil.getActualDate());
    this.end = DateUtil.getActualDate().split('T')[0];
    today.setDate(today.getDate() - 30);
    var other = new Date(today);
    var convert = DateUtil.parseDateToMilliseconds(other.toISOString());
    this.start = new Date(convert).toLocaleDateString('en-CA');
    this.getoptions();
  }

  getoptions() {
    this.billService.getOptions().subscribe({
      next: (response: ResponseObject) => {
        this.options = response.data.types;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error(error.error.message);
      }
    });
  }


  updateChart() {
    if (this.type && this.start && this.end) {
      this.loadingChart = true;
      document.getElementById("bill-receivable-chronology")['innerHTML'] = "";
      this.reportService.getBillReceivableReport(
        DateUtil.parseDateToMilliseconds(this.start),
        DateUtil.parseDateToMilliseconds(this.end),
        this.type
      ).subscribe({
        next: (response: ResponseObject) => {
          var categories = [];
          var total = [];
          for (let i = 0; i < response.data.length; i++) {
            const element = response.data[i];
            if (this.type == 0 && element.day == null && element.month == null && element.year == null) {
              categories.push("TOTAL");
            } else if (this.type == 1 && element.day == null && element.month == null && element.year != null) {
              categories.push(element.year);
            } else if (this.type == 2 && element.day == null && element.month != null) {
              categories.push(element.month);
            } else if (this.type == 3 && element.day != null) {
              categories.push(element.day);
            } else {
              continue;
            }
            total.push(element.total);
          }
          this.results = total;
          this.categories = categories;
          if (this.results.length != 0){
            this.buildChart();
          }
          this.loadingChart = false;
        },
        error: (error: HttpErrorResponse) => {
          this.loadingChart = false;
          this.toastService.error(error.error.message);
        }
      });
    }

  }

  buildChart() {
    const options = {
      chart: {
        height: 350,
        type: 'area',
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        curve: 'smooth'
      },
      series: [{
        name: 'Cuentas por Cobrar',
        data: this.results
      }],
      xaxis: {
        type: 'Días',
        categories: this.categories,
      },
      yaxis: {
        labels: {
          formatter: function (val) {
            return MathUtil.formatCurrency(val);
          }
        }

      },
      legend: {
        offsetY: -10,
      }
    }
    if (this.results.length > 0) {
      const chart = new ApexCharts(
        document.querySelector("#bill-receivable-chronology"),
        options
      );
      chart.render();
    } else {
      this.results = [];
    }
  }

}